import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { SubscriptionTabs } from "modules/subscription/components/SubscriptionTabs"

import "modules/subscription/lang"

export const Route = createFileRoute("/_base/_auth/settings/subscription")({
  component: SubscriptionTabs,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("subscription.title"),
    })
  },
})
